module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img244-03d85086bd0e8d0a913e22bdd102cb44.jpg";